import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import pinia, { initializeAllStores } from './stores'
import { useUserStore } from './stores/user'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/css/global.css'
import './assets/css/admin.css'
import axios from 'axios'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 明确定义特性标志，解决警告问题
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

const app = createApp(App)

// 使用 Pinia（新的状态管理）
app.use(pinia)

app.directive('permission', {
  mounted(el, binding) {
    const userStore = useUserStore()
    const value = binding.value
    let allowed = true
    if (Array.isArray(value)) {
      allowed = userStore.hasAllPermissions(value)
    } else if (typeof value === 'string') {
      allowed = userStore.hasPermission(value)
    }
    if (!allowed) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el)
      }
    }
  },
  updated(el, binding) {
    const userStore = useUserStore()
    const value = binding.value
    let allowed = true
    if (Array.isArray(value)) {
      allowed = userStore.hasAllPermissions(value)
    } else if (typeof value === 'string') {
      allowed = userStore.hasPermission(value)
    }
    if (!allowed) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el)
      }
    }
  }
})

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 配置axios默认值
axios.defaults.baseURL = '/api'

app.use(router).use(store)

app.use(ElementPlus, {
  locale: zhCn, // 使用中文语言包
})

// 初始化 Pinia stores
initializeAllStores()

app.mount('#app')
